import { render, staticRenderFns } from "./SubstituicaoPrestadoresAgiDownload.vue?vue&type=template&id=4a0de179"
import script from "./SubstituicaoPrestadoresAgiDownload.vue?vue&type=script&lang=js"
export * from "./SubstituicaoPrestadoresAgiDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports